import { cfg } from '../config/config';
import { axiosInstance } from './request';

export const sync = (srvName: string) =>
  axiosInstance.post<void>(`${cfg.apiUrl}/api/sync/${srvName}`);
